<template>
<v-app>
  <div class="login">
    <img src="../assets/logo.png" width="300px">
    <div class="display-2" style="margin: 50px;">Sitio de Gestión</div>

    <p class="text-md-center">
      <v-flex sm4 offset-sm4>
          <v-text-field
              label="Email"
              box
              v-model="email"
              required
          ></v-text-field>

          <v-text-field
              type="password" 
              label="Password"
              box
              v-model="password"
              required
          ></v-text-field>

          <br/>
          <v-btn v-on:click="login" color="primary">Enter</v-btn>
      </v-flex>
    </p>
  </div>
</v-app>
</template>

<script>
  import firebase from 'firebase'
  import { db } from '../main'

  export default {
    name: 'login',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login () {
        var vm = this;
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then((user) => {
          let userRef = db.collection("users").doc(user.user.uid);
          userRef.get().then(function(doc) {
              if (doc.exists) {
                  let d = doc.data()
                  
                  if (d.isAdmin) {
                    vm.$router.replace('/users');
                  } else {
                    //console.log("No such document!");
                    alert("Usuario inválido!");
                    firebase.auth().signOut().then(function() { }).catch(function(error) { });
                  }
              } else {
                  //console.log("No such document!");
                  alert("Usuario inválido!");
                  firebase.auth().signOut().then(function() { }).catch(function(error) { });
              }

          }).catch(function(error) {
              console.log("Error getting document:", error);
              alert("Error getting document:", error)
              firebase.auth().signOut().then(function() { }).catch(function(error) { });
          });

        }).catch((err) => {
          alert(err.message)
        })
      }
    },
    mounted: function () {
        var vm = this;
        this.$nextTick(function () {
          firebase.auth().onAuthStateChanged(function(user) {

            if (user) {
              //console.log('User is logged in.');
              let userRef = db.collection("users").doc(user.uid);
              userRef.get().then(function(doc) {
                  if (doc.exists) {
                      let d = doc.data()
                      
                      if (d.isAdmin) {
                        vm.$router.replace('/users');
                      } else {
                        //console.log("No such document!");
                        alert("Usuario inválido!");
                        firebase.auth().signOut().then(function() { }).catch(function(error) { });
                      }
                  } else {
                      //console.log("No such document!");
                      alert("Usuario inválido!");
                      firebase.auth().signOut().then(function() { }).catch(function(error) { });
                  }

              }).catch(function(error) {
                  //console.log("Error getting document:", error);
                  alert("Error getting document:", error)
                  firebase.auth().signOut().then(function() { }).catch(function(error) { });
              });
            } else {
              //console.log('User is NOT logged in.');
            }
          });
        })
    },
  }
</script>

<style scoped>
.login {
  margin-top: 40px;
  text-align: center;
}
input {
  align-self: center;
  margin: 10px 0;
  width: auto;
  padding: 15px;
}
button {
  margin: 10px 0;
  background-color: #0476F2;
}
a {
  color: black;
  text-decoration: underline;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
h1, h2 {
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue